import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['input', 'tabs']

  change(event) {
    const value = event.currentTarget.dataset.value
    this.inputTarget.value = value

    this.tabsTargets.forEach((tab) => {
      const active = tab.dataset.value === value
      tab.classList.toggle('font-semibold', active)
      tab.classList.toggle('bg-indigo-600', active)
      tab.classList.toggle('text-white', active)
      tab.classList.toggle('text-gray-500', !active)
      tab.classList.toggle('hover:bg-indigo-100', !active)
    })
  }

}
